export default __webpack_public_path__ + "static/media/logoDesktop.f8b9b051.svg";